module.exports = __webpack_public_path__ + "assets/img/00163.b7338de3.png";